module.exports = __webpack_public_path__ + "fonts/GT-Cinetype-Bold.a74bb652.ttf";